import {toast, toasterActions} from '@homeaway/react-toaster';
import {requestToBook} from './utils/requestToBook';

function chatbotRequestToBook(store) {
    return requestToBook(store, 'chat bot');
}

function triggerChatExitToast(store, action = {payload: {}}) {
    const {element, onClose} = action.payload;

    const exitToast = toast(element, {
        autoClose: 15000,
        onClose,
        type: 'inverse'
    });

    store.dispatch(toasterActions.addToast(exitToast));
}

export {chatbotRequestToBook, triggerChatExitToast};
